<ng-container *ngFor="let leg of legsDescription; let firstLeg=first; let lastLeg = last">
    <div class="leg-description">
        <div class="info-column">
            <span class="first-column">{{ (leg.startHour| date:'HH:mm') }}</span>
            <div class="icon-container"><mat-icon class="fromIcon"
                    svgIcon="{{firstLeg ? 'aFrom' : 'midStep'}}"></mat-icon></div>
            <span class="leg-description-title highlightedDescription">{{leg.from}}</span>
        </div>
        <div class="leg-description-column">
            <div class="vertical-icon first-column"><mat-icon class="modeIcon" svgIcon="{{leg.modeIcon}}"></mat-icon>
            </div>
            <div [ngClass]="leg.mode+'_line'"
                [style.border-right]="leg.mode==='BUS' ? ('3px solid #'+leg.routeColor)  : ''"></div>
            <div *ngIf="leg.mode === 'WALK' || leg.mode === 'BICYCLE'" class="steps-container">
                <ng-container *ngIf="leg.steps && leg.steps.length > 0">
                    <mat-accordion>
                        <mat-expansion-panel class="stops-expansion-panel">
                            <mat-expansion-panel-header> <mat-panel-title>{{('routeDetail.routeIndications' | transloco )|
                                    uppercase}}</mat-panel-title> </mat-expansion-panel-header>
                            <ng-container *ngFor="let step of leg.steps; let lastStep = last">
                                <div class="step-description">
                                    <span>
                                        <ng-container *ngIf="step.prefix;else notPrefix">
                                            <ng-container *ngIf="step.prefix === 'DEPART'">
                                                <span>{{'routeDetail.DEPART'| transloco}} </span> <span
                                                    class="highlightedDescription">{{step.from}} </span>
                                            </ng-container>
                                            <ng-container
                                                *ngIf="step.prefix === 'CIRCLE_CLOCKWISE' || step.prefix === 'CIRCLE_COUNTERCLOCKWISE'">
                                                <span>{{'routeDetail.takeCircle' | transloco}} </span>
                                                <span class="highlightedDescription">{{step.prefix ===
                                                    'CIRCLE_CLOCKWISE' ? ('routeDetail.CIRCLE_CLOCKWISE' | transloco) :
                                                    ''}} </span>
                                                <span class="highlightedDescription">{{step.prefix ===
                                                    'CIRCLE_COUNTERCLOCKWISE' ? ('routeDetail.CIRCLE_COUNTERCLOCKWISE' |
                                                    transloco) : ''}} </span>
                                                <span>{{'routeDetail.takeThe' | transloco}} </span>
                                                <span class="highlightedDescription">{{('routeDetail.'+step.exit) |
                                                    transloco}} </span>
                                                <span>{{'routeDetail.exit' | transloco}} </span>
                                            </ng-container>
                                        </ng-container>

                                        <ng-template #notPrefix>
                                            <span *ngIf="step.haveToTurnOn">{{'routeDetail.turnOn' | transloco}} </span>
                                            <span class="highlightedDescription">{{ ('routeDetail.'+step.action) |
                                                transloco}} </span>
                                        </ng-template>
                                        <ng-container *ngIf="step.bogusName && step.knownBogusName">
                                            <span>{{('routeDetail.prefix_'+step.streetName) |transloco}} </span>
                                            <span class="highlightedDescription">{{('routeDetail.'+step.streetName) |
                                                transloco}}</span>
                                        </ng-container>
                                        <ng-container *ngIf="!step.bogusName">
                                            <span>{{'routeDetail.direction' | transloco | lowercase}} </span>
                                            <span class="highlightedDescription">{{lastStep ? step.to :
                                                step.streetName}}</span>
                                        </ng-container>
                                        <ng-container *ngIf="step.bogusName && !step.knownBogusName">
                                            <span>{{('routeDetail.genericPrefix') |transloco}} </span>
                                            <span class="highlightedDescription">{{lastStep ? step.to :
                                                step.streetName}}</span>
                                        </ng-container>
                                    </span>
                                </div>
                            </ng-container>
                        </mat-expansion-panel>
                    </mat-accordion>
                </ng-container>
            </div>
            <div class="stops-container">
                <ng-container *ngIf="leg.mode === 'BUS' && leg.intermediateStops && leg.intermediateStops.length > 0">
                    <span><span [style.text-decoration-color]="'#' + leg.routeColor"
                            class="leg-name">{{leg.routeShortName}}</span> - <span>{{leg.route}}</span></span>
                    <mat-accordion *ngIf="leg.intermediateStops && leg.intermediateStops.length > 0">
                        <mat-expansion-panel class="stops-expansion-panel">
                            <mat-expansion-panel-header> <mat-panel-title>{{leg.intermediateStops.length}}
                                    {{'routeDetail.stops' | transloco | uppercase}}</mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="stops-name-container">
                                <ng-container *ngFor="let stop of leg.intermediateStops">
                                    <div class="stop-description">
                                        <span>{{stop}}</span>
                                    </div>
                                </ng-container>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </ng-container>
            </div>

        </div>
        <div *ngIf="lastLeg" class="info-column">
            <span>{{ (leg.endHour| date:'HH:mm') }}</span>
            <div class="icon-container"><mat-icon class="fromIcon" svgIcon="{{leg.toIcon}}"></mat-icon></div>
            <span class="leg-description-title highlightedDescription">{{leg.to}}</span>
        </div>
    </div>
</ng-container>
<div *ngIf="lineChartData && someLegOnBikeOrWalk" class="chart-container">
    <canvas baseChart width="400" height="200"
      [type]="'line'"
      [data]="lineChartData"
      [options]="lineChartOptions"
      >
    </canvas>
</div>